import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Form, Button, Card, Alert, Table } from "react-bootstrap";

const CreateCouponScreen = () => {
    const [code, setCode] = useState("");
    const [discountPercent, setDiscountPercent] = useState("");
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const [coupons, setCoupons] = useState([]);
    const [loadingCoupons, setLoadingCoupons] = useState(false);
    const [couponError, setCouponError] = useState("");

    const { userInfo } = useSelector((state) => state.userLogin);

    const fetchCoupons = async () => {
        try {
            setLoadingCoupons(true);
            const config = {
                headers: { Authorization: `Bearer ${userInfo.token}` },
            };
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/coupons`, config);
            setCoupons(data);
            setLoadingCoupons(false);
            setCouponError("");
        } catch (err) {
            setCouponError(
                err.response && err.response.data.message
                    ? err.response.data.message
                    : err.message
            );
            setLoadingCoupons(false);
        }
    };

    useEffect(() => {
        fetchCoupons();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess("");
        setError("");
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userInfo.token}`,
                },
            };
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/coupons`,
                { code, discountPercent },
                config
            );
            setSuccess("Coupon created successfully!");
            setCode("");
            setDiscountPercent("");
            fetchCoupons(); // Refresh coupon list after create
        } catch (err) {
            setError(
                err.response && err.response.data.message
                    ? err.response.data.message
                    : err.message
            );
        }
    };

    return (
        <>
            <Card className="p-4 my-4">
                <h2>Create Coupon</h2>
                {success && <Alert variant="success">{success}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="code" className="mb-3">
                        <Form.Label>Coupon Code</Form.Label>
                        <Form.Control
                            type="text"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            required
                            placeholder="E.g. NEW20"
                        />
                    </Form.Group>
                    <Form.Group controlId="discountPercent" className="mb-3">
                        <Form.Label>Discount % (e.g., 20)</Form.Label>
                        <Form.Control
                            type="number"
                            value={discountPercent}
                            min="1"
                            max="100"
                            onChange={(e) => setDiscountPercent(e.target.value)}
                            required
                            placeholder="E.g. 15"
                        />
                    </Form.Group>
                    <Button type="submit" variant="primary">
                        Create Coupon
                    </Button>
                </Form>
            </Card>

            {/* Coupon List below the form */}
            <h3>Existing Coupons</h3>
            {loadingCoupons ? (
                <p>Loading coupons...</p>
            ) : couponError ? (
                <Alert variant="danger">{couponError}</Alert>
            ) : coupons.length === 0 ? (
                <p>No coupons created yet.</p>
            ) : (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Discount %</th>
                            <th>Used</th>
                            <th>Used By</th>
                            <th>Used At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {coupons.map((coupon) => (
                            <tr key={coupon._id}>
                                <td>{coupon.code}</td>
                                <td>{coupon.discountPercent}</td>
                                <td>{coupon.isUsed ? "Yes" : "No"}</td>
                                <td>
                                    {coupon.usedBy
                                        ? `${coupon.usedBy.name.split(" ").slice(0, 3).join(" ")} (${coupon.usedBy.email})`
                                        : "N/A"}
                                </td>
                                <td>{coupon.usedAt ? new Date(coupon.usedAt).toLocaleString() : "N/A"}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </>
    );
};

export default CreateCouponScreen;
